module.exports = __webpack_public_path__ + "img/qr-slide-bg1.16cd01a3.png";